import { combineReducers } from 'redux';
import { saveReduxStateToStorage } from '../../assets/helpers/utils';
import { deleteAllAffiliateParams } from '../../assets/helpers/affiliateHelper';

import session from './session';
import myLocation from './myLocation';
import searchLocation from './searchLocation';
import confirmEmail from './confirmEmail';
import createAccountData from './createAccountData';
import emailRegister from './emailRegister';
import appleAuth from './appleAuth';
import appleData from './appleData';
import checkUsername from './checkUsername';
import checkFirstName from './checkFirstName';
import emailLogin from './emailLogin';
import logout from './logout';
import getMyMatches from './getMyMatches';
import userListMyMatches from './userListMyMatches';
import getQuickMatches from './getQuickMatches';
import itsMatch from './itsMatch';
import inviteAction from './inviteAction';
import getAds from './getAds';
import calculatedPayoutValue from './calculatePayoutValue';
import getAdsSideMenu from './getAdsSideMenu';
import getAdsGrid from './getAdsGrid';
import getListAds from './getListAds';
import listAds from './listAds';
import getLogoutAds from './getLogoutAds';
import userListQuickMatches from './userListQuickMatches';
import getMyProfile from './getMyProfile';
import scrollPosition from './scrollPosition';
import getMyLikes from './getMyLikes';
import getLikesMe from './getLikesMe';
import getMutualLikes from './getMutualLikes';
import userListMyLikes from './userListMyLikes';
import userListLikesMe from './userListLikesMe';
import userListMutualLikes from './userListMutualLikes';
import getMyViews from './getMyViews';
import getViewedMe from './getViewedMe';
import userListMyViews from './userListMyViews';
import userListViewedMe from './userListViewedMe';
import getWhoIsOnlineRecent from './getWhoIsOnlineRecent';
import whoIsOnlineRecentImageGrid from './whoIsOnlineRecentImageGrid';
import getWhoIsOnlineWeek from './getWhoIsOnlineWeek';
import whoIsOnlineWeekImageGrid from './whoIsOnlineWeekImageGrid';
import getBrowse from './getBrowse';
import imageUserListBrowse from './imageUserListBrowse';
import getMyFavorites from './getMyFavorites';
import userListMyFavorites from './userListMyFavorites';
import getFavoritedMe from './getFavoritedMe';
import userListFavoritedMe from './userListFavoritedMe';
import getMemberProfile from './getMemberProfile';
import socketData from './socket';
import contactUs from './contactUs';
import getPreferences from './getPreferences';
import getChats from './getChats';
import updateLocation from './updateLocation';
import userListChats from './userListChats';
import userListSentMessages from './userListSentMessages';
import messages from './messages';
import userData from './userData';
import typing from './userIsTyping';
import getSearchControls from './getSearchControls';
import searchUsers from './searchUsers';
import userListSearch from './userListSearch';
import searchControls from './searchControls';
import getProfileControls from './getProfileControls';
import forgotPassword from './forgotPassword';
import setNewPassword from './setNewPassword';
import editProfile from './editProfile';
import swapImages from './swapImages';
import deleteImage from './deleteImage';
import uploadImage from './uploadImage';
import uploadImageToCDN from './uploadImageToCDN';
import onboardingUploadImage from './onboardingUploadImage';
import imageForUpload from './imageForUpload';
import reportUser from './reportUser';
import confirmOptIn from './confirmOptIn';
import blockUser from './blockUser';
import deleteUserChatAndUnmatch from './deleteUserChatAndUnmatch';
import deactivateAccount from './deactivateAccount';
import reactivateWebSubscription from './reactivateWebSubscription';
import deleteAccount from './deleteAccount';
import checkAccountStatus from './checkAccountStatus';
import favoriteUser from './favoriteUser';
import requestUserPhoto from './requestUserPhoto';
import getFlirtMessages from './getFlirtMessages';
import getWebSubscription from './getWebSubscription';
import getSubscriptionsList from './getSubscriptionsList';
import paymentData from './paymentData';
import getConfig from './getConfig';
import happyHour from './happyHour';
import initWebPayment from './initWebPayment';
import finishWebPayment from './finishWebPayment';
import activateVip from './activateVip';
import enablePrivate from './enablePrivate';
import disablePrivate from './disablePrivate';
import removeUnseenFlag from './removeUnseenFlag';
import removeUnopenedFlag from './removeUnopenedFlag';
import refreshData from './refreshData';
import setAcknowledged from './setAcknowledged';
import resetUserLists from './resetUserLists';
import addUnsubscribeReason from './addUnsubscribeReason';
import resubscribeEmail from './resubscribeEmail';
import unsubscribeEmail from './unsubscribeEmail';
import trackAffiliateClick from './trackAffiliateClick';
import editProfileData from './editProfileData';
import storedAds from './storeAdsLocally';
import setDoNotSellInfo from './setDoNotSellInfo';
import getCrossSaleOffer from './getCrossSaleOffer';
import getStepdownSubscription from './getStepdownSubscription';
import transCoregLookup from './transCoregLookup';
import language from './language';
import oneClickSignup from './oneClickSignup';
import oneClickLogin from './oneClickLogin';
import signupCoreg from './signupCoreg';
import setNearbyConnectMessage from './setNearbyConnectMessage';
import refundWithNewCreditCard from './refundWithNewCreditCard';
import modals from './modals';
import onboarding from './onboarding';
import getNearbyConnectStatus from './getNearbyConnectStatus';
import disableNearbyConnectSetup from './disableNearbyConnectSetup';
import updateNearbyConnectSetup from './updateNearbyConnectSetup';
import checkPublicText from './checkPublicText';
import cookiesModal from './cookiesModal';
import resendConfirmationEmail from './resendConfirmationEmail';
import cancelWebSubscription from './cancelWebSubscription';
import metaPixels from './metaPixels';

const appReducer = combineReducers({
  /* application top-level reducers */
  session,
  myLocation,
  searchLocation,
  confirmEmail,
  createAccountData,
  emailRegister,
  appleAuth,
  appleData,
  checkUsername,
  checkFirstName,
  emailLogin,
  logout,
  getMyMatches,
  getQuickMatches,
  itsMatch,
  inviteAction,
  getAds,
  calculatedPayoutValue,
  getAdsSideMenu,
  getAdsGrid,
  getListAds,
  listAds,
  getLogoutAds,
  userListMyMatches,
  userListQuickMatches,
  getMyProfile,
  scrollPosition,
  getMyLikes,
  getLikesMe,
  getMutualLikes,
  userListMyLikes,
  userListLikesMe,
  userListMutualLikes,
  getMyViews,
  getViewedMe,
  userListMyViews,
  userListViewedMe,
  getWhoIsOnlineRecent,
  whoIsOnlineRecentImageGrid,
  getWhoIsOnlineWeek,
  whoIsOnlineWeekImageGrid,
  getBrowse,
  deactivateAccount,
  reactivateWebSubscription,
  deleteAccount,
  checkAccountStatus,
  imageUserListBrowse,
  getMyFavorites,
  userListMyFavorites,
  getFavoritedMe,
  userListFavoritedMe,
  getMemberProfile,
  contactUs,
  getPreferences,
  socketData,
  getChats,
  updateLocation,
  userListChats,
  userListSentMessages,
  messages,
  userData,
  typing,
  getSearchControls,
  searchUsers,
  userListSearch,
  searchControls,
  getProfileControls,
  forgotPassword,
  setNewPassword,
  editProfile,
  swapImages,
  confirmOptIn,
  deleteImage,
  uploadImage,
  uploadImageToCDN,
  onboardingUploadImage,
  imageForUpload,
  reportUser,
  blockUser,
  deleteUserChatAndUnmatch,
  favoriteUser,
  requestUserPhoto,
  getFlirtMessages,
  getWebSubscription,
  getSubscriptionsList,
  paymentData,
  getConfig,
  happyHour,
  addUnsubscribeReason,
  resubscribeEmail,
  unsubscribeEmail,
  initWebPayment,
  finishWebPayment,
  activateVip,
  enablePrivate,
  disablePrivate,
  removeUnseenFlag,
  removeUnopenedFlag,
  refreshData,
  setAcknowledged,
  resetUserLists,
  trackAffiliateClick,
  editProfileData,
  storedAds,
  setDoNotSellInfo,
  getCrossSaleOffer,
  getStepdownSubscription,
  transCoregLookup,
  language,
  oneClickSignup,
  oneClickLogin,
  signupCoreg,
  setNearbyConnectMessage,
  refundWithNewCreditCard,
  modals,
  onboarding,
  getNearbyConnectStatus,
  disableNearbyConnectSetup,
  updateNearbyConnectSetup,
  checkPublicText,
  cookiesModal,
  resendConfirmationEmail,
  cancelWebSubscription,
  metaPixels,
});

const rootReducer = (state, action) => {
  if (
    [
      'NBS_API_LOGOUT_REQUEST',
      'NBS_API_LOGOUT_SUCCESS',
      'NBS_API_DEACTIVATE_ACCOUNT_SUCCESS',
      'NBS_API_DELETE_ACCOUNT_SUCCESS',
    ].includes(action.type)
  ) {
    // state = undefined;
    deleteAllAffiliateParams();
    let newState = {
      checkAccountStatus: state.checkAccountStatus,
    };
    state = newState;
  } else if (['INVALID_SOCKET_AUTH'].includes(action.type)) {
    state = {};
  } else if (action.type === 'SAVE_REDUX_STATE_TO_STORAGE') {
    // console.log('SAVE REDUX TO STORAGE');
    const {
      getMyProfile,
      getConfig,
      initWebPayment,
      getWebSubscription,
      paymentData,
      getSubscriptionsList,
      socketData,
      listAds,
    } = state;
    // saveReduxStateToStorage(state);
    saveReduxStateToStorage({
      getMyProfile,
      getConfig,
      initWebPayment,
      getWebSubscription,
      // never persist card data (PAN/CVV) to localStorage
      paymentData: {
        ...paymentData,
        billingData: {
          cardName: '',
          cardNumber: '',
          cardMonth: '',
          cardYear: '',
          cardCvv: '',
          tosAccepted: false,
        },
      },
      getSubscriptionsList,
      socketData,
      listAds,
    });
  }

  return appReducer(state, action);
};

export default rootReducer;
